import { inject, injectable } from 'inversify';
import { HttpService } from 'src/core/services/http.service';


@injectable()
export class RulesReflectionService {
	@inject(HttpService)
	private httpService: HttpService;

	private baseUrl = 'api/v1/models/reflection';

	public async getPublicEvents(): Promise<PublicEventItem[]> {
		return (await this.httpService.get(`${this.baseUrl}/events`)).data;
	}

	public async getConditionDefinitions(mapType: string): Promise<ConditionDefinitionItem[]> {
		return (await this.httpService.post(`${this.baseUrl}/conditions`, { mapType})).data;
	}


	public async getRuleExecutors(mapType: string): Promise<ConditionDefinitionItem[]> {
		return (await this.httpService.post(`${this.baseUrl}/executors`, {mapType})).data;
	}
}



// WEBPACK FOOTER //
// ./src/app/rules/rules/rules.reflection.service.ts